module.exports = __webpack_public_path__ + "img/ch14_02_进村全村瞩目.47ba1167.jpg";